import React from 'react';
import { Box, makeStyles } from '@material-ui/core';
import ArrowDown from '../../shared/assets/down.png';

const useStyle = makeStyles({
  footerStyle: {
    backgroundColor: '#818293',
    textAlign: 'center',
  },
  imgStyle: {
    userDrag: 'none',
    height: 50,
    margin: '10px 0 50px 0',
  },
});

export const IntroFooter = () => {
  const classes = useStyle();
  return (
    <Box
      className={classes.footerStyle}
      onClick={() => window.scrollBy({ top: 800, behavior: 'smooth' })}
    >
      <img className={classes.imgStyle} src={ArrowDown} alt="down" />
    </Box>
  );
};
